import { FC } from 'react';
import { formAction } from './action';
import { FranchiseRemarketingClientForm } from './FranchiseRemarketingClientForm';

export const FranchiseRemarketingForm: FC = () => {
    return <FranchiseRemarketingClientForm formAction={formAction} />;
};
